import { apiCall } from "./service";
import { URL_TASKGROUPS, URL_TASK } from "./URL";

export const api = {
  getTaskGroupTasksRequest(params) {
    const { scopeId, taskGroupId } = params;
    return apiCall.get({
      url: `${URL_TASK}${scopeId}/Tasks?TaskGroupId=${taskGroupId}`,
      isAuthToken: true,
    });
  },

  getTaskGroupsRequest(params) {
    const { scopeId } = params;
    return apiCall.get({
      url: `${URL_TASKGROUPS}?scopeId=${scopeId}`,
      isAuthToken: true,
    });
  },

  getTaskGroupDetailsRequest(params) {
    return apiCall.get({
      url: `${URL_TASKGROUPS}/${params.id}`,
      isAuthToken: true,
    });
  },

  getTaskGroupProgressSummaryRequest(params) {
    return apiCall.get({
      url: `${URL_TASKGROUPS}/${params.id}/progress-summary`,
      isAuthToken: true,
    });
  },

  createTaskGroupRequest(params) {
    return apiCall.post({
      url: `${URL_TASKGROUPS}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateTaskGroupRequest(params) {
    return apiCall.put({
      url: `${URL_TASKGROUPS}/${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteTaskGroupRequest(params) {
    return apiCall.delete({
      url: `${URL_TASKGROUPS}/${params.id}`,
      isAuthToken: true,
    });
  },

  duplicateTaskGroupRequest(params) {
    return apiCall.post({
      url: `${URL_TASKGROUPS}/${params.id}/duplicate`,
      isAuthToken: true,
      params: params.payload || {},
    });
  },

  patchTaskGroupField(id, field, value) {
    return apiCall.patch({
      url: `${URL_TASKGROUPS}/${id}`,
      isAuthToken: true,
      params: [{ op: "replace", path: `/${field}`, value }],
    });
  },
};

export default api;
